import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions as unitTestsActions } from '../../../../../../../store/reducers/unit-tests.reducer'
import TestModal from '../TestModal'

const CreateStdinTestModal = ({ showCreateStdinTestModal, setShowCreateStdinTestModal, createStdinTest }) => {
    const [errorMessage, setErrorMessage] = useState('')

    const handleSubmitTest = (token, fields) => {
        setErrorMessage('')
        return createStdinTest(token, fields, setErrorMessage)
    }

    return (
        <TestModal
            showModal={showCreateStdinTestModal}
            setShowModal={setShowCreateStdinTestModal}
            submitTest={handleSubmitTest}
            modalTitle='Create stdin test'
            submitButtonText='Create'
            fields={{
                name: true,
                input: true,
                cpuTimeLimit: true,
                memoryLimit: true,
                exactMatch: true,
                ignoreCase: true,
                fixtureFiles: true,
            }}
            errorMessage={errorMessage}
        />
    )
}

const mapState = ({ unitTests }) => {
    return {
        showCreateStdinTestModal: unitTests.showCreateStdinTestModal,
    }
}

const mapDispatch = dispatch => {
    return {
        setShowCreateStdinTestModal: value => {
            dispatch(unitTestsActions.setShowCreateStdinTestModal(value))
        },
        createStdinTest: (token, fields, setResponseMessage) => {
            return dispatch(unitTestsActions.createStdinTest(token, fields, setResponseMessage))
        },
    }
}

export default connect(mapState, mapDispatch)(CreateStdinTestModal)
